export default "/images/72ea4c356366417d0d798f0024587066.avif";